import { createSlice } from "@reduxjs/toolkit";
import i18n from "../i18n";

// ภาษาของหน้าเว็บ — ไทยเป็นค่าตั้งต้น · อังกฤษสำหรับพนักงานต่างชาติ (22 ต.ค. 2569 ผู้ใช้สั่งเปิด 2 ภาษา)
//   เดิม 13 ต.ค. 69 ล็อกเป็นไทยล้วน — ยกเลิกแล้ว
//   ที่เก็บค่า: localStorage "pawin_lang" = "th" | "en" (ต่อเครื่อง/เบราว์เซอร์) · i18next ใช้ค่าเดียวกัน (i18n.js)
//   state.language = "thai" | "en" — หน้าเก่า ~50 ไฟล์อ่าน state.language === "thai"
//   ⚠ ห้ามใช้ "english": หน้าเก่า 16 หน้าเลือกป้ายด้วย { en: {...}, thai: {...} }[language] — "english" ไม่ตรงคีย์ไหน
//     หน้าพังทั้งหน้า (เคยเกิด 26 ส.ค. 69 commit c2d126f และซ้ำ 22 ต.ค. 69 · แก้กลับ 23 ต.ค. 69)
const toState = (code) => (code === "en" ? "en" : "thai");
const readStored = () => {
  try {
    return toState(localStorage.getItem("pawin_lang") === "en" ? "en" : "th");
  } catch {
    return "thai";
  }
};
const persist = (code) => {
  try {
    localStorage.setItem("pawin_lang", code);
    localStorage.setItem("appLanguage", JSON.stringify(toState(code)));
  } catch { /* เก็บไม่ได้ (โหมดส่วนตัว) — ใช้ค่าในหน้านี้ไปก่อน */ }
  if (i18n.language !== code) i18n.changeLanguage(code);
  try { document.documentElement.lang = code; } catch { /* ไม่มี document ตอนทดสอบ */ }
};

const languageSlice = createSlice({
  name: "language",
  initialState: { language: readStored() },
  reducers: {
    // payload: "th" | "en" (หรือ "thai" | "english" แบบเดิม)
    setLanguage: (state, action) => {
      const code = action.payload === "en" || action.payload === "english" ? "en" : "th";
      state.language = toState(code);
      persist(code);
    },
    // ชื่อเดิม — ยังมีที่เรียกอยู่
    setLanguageCredentials: (state, action) => {
      const code = action.payload === "en" || action.payload === "english" ? "en" : "th";
      state.language = toState(code);
      persist(code);
    },
    resetLanguage: (state) => {
      state.language = "thai";
      persist("th");
    },
  },
});

export const { setLanguage, setLanguageCredentials, resetLanguage } = languageSlice.actions;

export default languageSlice.reducer;
